import React, { forwardRef, SVGProps } from 'react';

import { Enums } from '@components/SurveyBuilder';

export const SurveyBuilderSpriteSVG = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} {...props} xmlns='http://www.w3.org/2000/svg'>
    <symbol id={Enums.Kind.welcome} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g id='house-1 1'>
        <path
          id='Vector'
          d='M4.26843 13.8225V21.5569H9.89343V15.9319C9.89343 15.5589 10.0416 15.2012 10.3053 14.9375C10.569 14.6738 10.9267 14.5256 11.2997 14.5256H12.7059C13.0789 14.5256 13.4366 14.6738 13.7003 14.9375C13.964 15.2012 14.1122 15.5589 14.1122 15.9319V21.5569H19.7372V13.8225'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_2'
          d='M1.45593 12.4163L11.0081 2.8641C11.1387 2.73343 11.2938 2.62976 11.4645 2.55903C11.6351 2.48831 11.8181 2.4519 12.0028 2.4519C12.1876 2.4519 12.3705 2.48831 12.5412 2.55903C12.7118 2.62976 12.8669 2.73343 12.9975 2.8641L22.5497 12.4163'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </symbol>
    <symbol
      id={Enums.Kind.prototypeTest}
      width='24'
      height='27'
      viewBox='0 0 16 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.5 12.0938V3.65625C1.5 3.35788 1.60536 3.07173 1.79289 2.86075C1.98043 2.64978 2.23478 2.53125 2.5 2.53125H13.5C13.7652 2.53125 14.0196 2.64978 14.2071 2.86075C14.3946 3.07173 14.5 3.35788 14.5 3.65625V12.0938'
        stroke='currentColor'
        strokeWidth='1'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.72267 12.0938C9.54915 12.4354 9.29841 12.7194 8.99589 12.9169C8.69336 13.1145 8.34979 13.2185 8 13.2185C7.65021 13.2185 7.30664 13.1145 7.00411 12.9169C6.70159 12.7194 6.45085 12.4354 6.27733 12.0938H0.5V13.2188C0.5 13.8155 0.710714 14.3878 1.08579 14.8097C1.46086 15.2317 1.96957 15.4687 2.5 15.4688H13.5C14.0304 15.4687 14.5391 15.2317 14.9142 14.8097C15.2893 14.3878 15.5 13.8155 15.5 13.2188V12.0938H9.72267Z'
        stroke='currentColor'
        strokeWidth='1'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.28267 5.40454C7.19971 5.36066 7.10855 5.34 7.01697 5.34431C6.92538 5.34862 6.83608 5.37777 6.75667 5.42929C6.67958 5.47839 6.6153 5.54939 6.57026 5.63521C6.52522 5.72102 6.50099 5.81863 6.5 5.91829V8.70679C6.50106 8.80642 6.52531 8.904 6.57035 8.98981C6.61538 9.07561 6.67962 9.14663 6.75667 9.19579C6.83608 9.2473 6.92538 9.27645 7.01697 9.28076C7.10855 9.28507 7.19971 9.26441 7.28267 9.22054L9.60867 7.98529C9.72495 7.92808 9.82389 7.83398 9.89337 7.71449C9.96285 7.595 9.99986 7.45532 9.99986 7.31254C9.99986 7.16975 9.96285 7.03007 9.89337 6.91058C9.82389 6.79109 9.72495 6.69699 9.60867 6.63979L7.28267 5.40454Z'
        stroke='currentColor'
        strokeWidth='1'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </symbol>
    <symbol id={Enums.Kind.yesNo} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g id='symbol-not-equal-1 1' clipPath='url(#clip0_1770_6249)'>
        <path
          id='Vector'
          d='M10 1L4.16487 7.47295C4.00447 7.65037 3.78721 7.75 3.5607 7.75C3.33419 7.75 3.11692 7.65037 2.95652 7.47295L1 5.30141'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_2'
          d='M1.45312 22.5459L22.5469 1.45215'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_3'
          d='M16 23L23 16'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_4'
          d='M23 23L16 16'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_1770_6249'>
          <rect width='24' height='24' fill='currentColor' />
        </clipPath>
      </defs>
    </symbol>
    <symbol id={Enums.Kind.longText} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g id='text-style 1'>
        <path
          id='Vector'
          d='M2.15625 4.26379V3.56254C2.156 3.28538 2.21038 3.01088 2.31628 2.75475C2.42217 2.49861 2.57751 2.26585 2.77341 2.06978C2.96931 1.87371 3.20193 1.71816 3.45797 1.61204C3.71401 1.50592 3.98846 1.45129 4.26563 1.45129H19.7344C20.0115 1.45129 20.286 1.50592 20.542 1.61204C20.7981 1.71816 21.0307 1.87371 21.2266 2.06978C21.4225 2.26585 21.5778 2.49861 21.6837 2.75475C21.7896 3.01088 21.844 3.28538 21.8438 3.56254V4.26567'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_2'
          d='M12 1.45129V22.545'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_3'
          d='M7.78125 22.545H16.2188'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </symbol>
    <symbol id={Enums.Kind.shortText} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g id='text-style 1'>
        <path
          id='Vector'
          d='M2.15625 4.26379V3.56254C2.156 3.28538 2.21038 3.01088 2.31628 2.75475C2.42217 2.49861 2.57751 2.26585 2.77341 2.06978C2.96931 1.87371 3.20193 1.71816 3.45797 1.61204C3.71401 1.50592 3.98846 1.45129 4.26563 1.45129H19.7344C20.0115 1.45129 20.286 1.50592 20.542 1.61204C20.7981 1.71816 21.0307 1.87371 21.2266 2.06978C21.4225 2.26585 21.5778 2.49861 21.6837 2.75475C21.7896 3.01088 21.844 3.28538 21.8438 3.56254V4.26567'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_2'
          d='M12 1.45129V22.545'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_3'
          d='M7.78125 22.545H16.2188'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </symbol>
    <symbol id={Enums.Kind.website} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g id='earth-3(2) 1' clipPath='url(#clip0_1770_6331)'>
        <g id='Group'>
          <path
            id='Vector'
            d='M1.45313 12C1.45312 13.385 1.72593 14.7565 2.25596 16.0361C2.78599 17.3157 3.56287 18.4784 4.54223 19.4578C5.5216 20.4371 6.68428 21.214 7.96389 21.744C9.24349 22.2741 10.615 22.5469 12 22.5469C13.385 22.5469 14.7565 22.2741 16.0361 21.744C17.3157 21.214 18.4784 20.4371 19.4578 19.4578C20.4371 18.4784 21.214 17.3157 21.744 16.0361C22.2741 14.7565 22.5469 13.385 22.5469 12C22.5469 10.615 22.2741 9.24349 21.744 7.96389C21.214 6.68428 20.4371 5.5216 19.4578 4.54223C18.4784 3.56287 17.3157 2.78599 16.0361 2.25596C14.7565 1.72593 13.385 1.45313 12 1.45312C10.615 1.45313 9.24349 1.72593 7.96389 2.25596C6.68428 2.78599 5.5216 3.56287 4.54223 4.54223C3.56287 5.5216 2.78599 6.68428 2.25596 7.96389C1.72593 9.24349 1.45312 10.615 1.45313 12Z'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M10.0125 22.3594C8.54062 20.2969 7.54688 16.425 7.54688 12.0469C7.54688 7.66875 8.54062 3.70312 10.0125 1.6875'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_3'
            d='M13.9875 22.3594C15.4594 20.2969 16.4531 16.425 16.4531 12.0469C16.4531 7.66875 15.4594 3.70312 13.9875 1.6875'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_4'
            d='M1.45312 12H22.5469'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_5'
            d='M2.67188 16.9219H21.3281'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_6'
            d='M2.67188 7.07812H21.3281'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_1770_6331'>
          <rect width='24' height='24' fill='currentColor' />
        </clipPath>
      </defs>
    </symbol>
    <symbol id={Enums.Kind.number} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g id='number 1'>
        <path
          id='Vector'
          d='M12.615 2.03162V10.1757'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_2'
          d='M9.89999 4.06787H10.5787C11.7037 4.06787 12.615 3.15662 12.615 2.03162'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_3'
          d='M15.3272 10.1757H9.89813'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_4'
          d='M15.3281 20.6109C15.4686 21.0081 15.7287 21.3519 16.0728 21.5951C16.4168 21.8382 16.8278 21.9686 17.2491 21.9684H18.6066C19.7316 21.9684 20.6419 21.0562 20.6419 19.9322V19.5928C20.6419 18.4678 19.7306 17.5565 18.6066 17.5565H17.9278H18.4369C18.9318 17.5565 19.4064 17.3599 19.7564 17.01C20.1064 16.66 20.303 16.1854 20.303 15.6904C20.303 15.1955 20.1064 14.7209 19.7564 14.3709C19.4064 14.0209 18.9318 13.8243 18.4369 13.8243H17.4188C16.5647 13.8243 15.8438 14.3981 15.6225 15.1818'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_5'
          d='M8.78625 21.9684H3.35812V20.8115C3.35812 20.0025 3.83625 19.2703 4.57687 18.9459L7.59844 17.624C8.01584 17.4416 8.35771 17.121 8.56655 16.7162C8.77539 16.3114 8.83847 15.847 8.74518 15.4011C8.65189 14.9552 8.40792 14.5551 8.0543 14.2679C7.70068 13.9808 7.25896 13.8241 6.80344 13.8243H5.39344C4.50656 13.8243 3.75281 14.3906 3.47344 15.1818'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </symbol>
    <symbol id={Enums.Kind.singleSelect} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g id='coding-apps-website-web-form-radio-button-2 1' clipPath='url(#clip0_1770_6359)'>
        <path
          id='Vector'
          d='M1.45313 12C1.45312 13.385 1.72593 14.7565 2.25596 16.0361C2.78599 17.3157 3.56287 18.4784 4.54223 19.4578C5.5216 20.4371 6.68428 21.214 7.96389 21.744C9.24349 22.2741 10.615 22.5469 12 22.5469C13.385 22.5469 14.7565 22.2741 16.0361 21.744C17.3157 21.214 18.4784 20.4371 19.4578 19.4578C20.4371 18.4784 21.214 17.3157 21.744 16.0361C22.2741 14.7565 22.5469 13.385 22.5469 12C22.5469 10.615 22.2741 9.24349 21.744 7.96389C21.214 6.68428 20.4371 5.5216 19.4578 4.54223C18.4784 3.56287 17.3157 2.78599 16.0361 2.25596C14.7565 1.72593 13.385 1.45313 12 1.45312C10.615 1.45313 9.24349 1.72593 7.96389 2.25596C6.68428 2.78599 5.5216 3.56287 4.54223 4.54223C3.56287 5.5216 2.78599 6.68428 2.25596 7.96389C1.72593 9.24349 1.45312 10.615 1.45313 12Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_1770_6359'>
          <rect width='24' height='24' fill='currentColor' />
        </clipPath>
      </defs>
    </symbol>
    <symbol id={Enums.Kind.email} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g id='email-action-unread 2'>
        <path
          id='Vector'
          d='M2.15625 5.20312H21.8438V19.2656H2.15625V5.20312Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_2'
          d='M21.5259 5.71875L13.8909 11.5913C13.3488 12.0083 12.684 12.2344 12 12.2344C11.316 12.2344 10.6512 12.0083 10.1091 11.5913L2.47406 5.71875'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </symbol>
    <symbol id={Enums.Kind.linearScale} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g id='list-numbers 1' clipPath='url(#clip0_1770_6388)'>
        <g id='Group'>
          <path
            id='Vector'
            d='M8.48438 3.5625H22.5469'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M8.48438 12H22.5469'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_3'
            d='M8.48438 20.4375H22.5469'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_4'
            d='M1.5 17.9625C1.56821 17.7092 1.70591 17.48 1.89755 17.3009C2.08919 17.1217 2.32711 16.9997 2.58444 16.9487C2.84177 16.8977 3.10824 16.9197 3.35372 17.0122C3.59921 17.1047 3.81393 17.264 3.97361 17.4721C4.13329 17.6803 4.23157 17.9289 4.25734 18.19C4.2831 18.4511 4.23533 18.7141 4.11942 18.9495C4.0035 19.1848 3.82407 19.383 3.60141 19.5217C3.37874 19.6604 3.12171 19.7341 2.85938 19.7344C3.12119 19.7351 3.37759 19.809 3.59971 19.9475C3.82184 20.0861 4.00086 20.284 4.11663 20.5188C4.2324 20.7536 4.28031 21.0161 4.25498 21.2767C4.22964 21.5373 4.13206 21.7856 3.97323 21.9938C3.81439 22.2019 3.60061 22.3615 3.35595 22.4547C3.11129 22.5479 2.84546 22.571 2.58841 22.5213C2.33136 22.4716 2.09328 22.3511 1.90099 22.1735C1.70869 21.9958 1.56982 21.768 1.5 21.5156'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_5'
            d='M1.45312 11.2969C1.45312 10.9239 1.60128 10.5662 1.86501 10.3025C2.12873 10.0388 2.48641 9.89062 2.85938 9.89062C3.23234 9.89062 3.59002 10.0388 3.85374 10.3025C4.11747 10.5662 4.26562 10.9239 4.26562 11.2969C4.26453 11.7533 4.10926 12.196 3.825 12.5531L1.45312 14.1094H4.26562'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <g id='Group_2'>
            <path
              id='Vector_6'
              d='M1.45312 1.45312H2.15625C2.34198 1.45555 2.51941 1.53041 2.65075 1.66175C2.78209 1.79309 2.85695 1.97052 2.85938 2.15625V7.07812'
              stroke='currentColor'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='Vector_7'
              d='M1.45312 7.07812H4.26562'
              stroke='currentColor'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id='clip0_1770_6388'>
          <rect width='24' height='24' fill='currentColor' />
        </clipPath>
      </defs>
    </symbol>
    <symbol id={Enums.Kind.multiSelect} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g id='list-bullets-1(1) 1' clipPath='url(#clip0_1770_6408)'>
        <g id='Group'>
          <path
            id='Vector'
            d='M8.48438 3.5625H22.5469'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M8.48438 12H22.5469'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_3'
            d='M8.48438 20.4375H22.5469'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_4'
            d='M2.15625 1.45312H4.96875C4.96875 1.45312 5.67188 1.45312 5.67188 2.15625V4.96875C5.67188 4.96875 5.67188 5.67188 4.96875 5.67188H2.15625C2.15625 5.67188 1.45312 5.67188 1.45312 4.96875V2.15625C1.45312 2.15625 1.45312 1.45312 2.15625 1.45312Z'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_5'
            d='M2.15625 9.89062H4.96875C4.96875 9.89062 5.67188 9.89062 5.67188 10.5938V13.4062C5.67188 13.4062 5.67188 14.1094 4.96875 14.1094H2.15625C2.15625 14.1094 1.45312 14.1094 1.45312 13.4062V10.5938C1.45312 10.5938 1.45312 9.89062 2.15625 9.89062Z'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_6'
            d='M2.15625 18.3281H4.96875C4.96875 18.3281 5.67188 18.3281 5.67188 19.0312V21.8438C5.67188 21.8438 5.67188 22.5469 4.96875 22.5469H2.15625C2.15625 22.5469 1.45312 22.5469 1.45312 21.8438V19.0312C1.45312 19.0312 1.45312 18.3281 2.15625 18.3281Z'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_1770_6408'>
          <rect width='24' height='24' fill='currentColor' />
        </clipPath>
      </defs>
    </symbol>
    <symbol id={Enums.Kind.date} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g id='calendar 1' clipPath='url(#clip0_1770_6424)'>
        <path
          id='Vector'
          d='M2.86125 4.26562H21.1425C21.1425 4.26562 22.5487 4.26562 22.5487 5.67188V21.1406C22.5487 21.1406 22.5487 22.5469 21.1425 22.5469H2.86125C2.86125 22.5469 1.455 22.5469 1.455 21.1406V5.67188C1.455 5.67188 1.455 4.26562 2.86125 4.26562Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_2'
          d='M1.455 9.89062H22.5487'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_3'
          d='M7.08 6.375V1.45312'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_4'
          d='M16.9237 6.375V1.45312'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_1770_6424'>
          <rect width='24' height='24' fill='currentColor' />
        </clipPath>
      </defs>
    </symbol>
    <symbol id={Enums.Kind.location} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g id='pin-location-1 1'>
        <path
          id='Vector'
          d='M9.1875 7.78125C9.1875 8.52717 9.48382 9.24254 10.0113 9.76999C10.5387 10.2974 11.2541 10.5937 12 10.5938C12.7459 10.5937 13.4613 10.2974 13.9887 9.76999C14.5162 9.24254 14.8125 8.52717 14.8125 7.78125C14.8125 7.03533 14.5162 6.31996 13.9887 5.79251C13.4613 5.26507 12.7459 4.96875 12 4.96875C11.2541 4.96875 10.5387 5.26507 10.0113 5.79251C9.48382 6.31996 9.1875 7.03533 9.1875 7.78125Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_2'
          d='M12 1.45312C13.6783 1.45313 15.2879 2.11984 16.4747 3.30659C17.6614 4.49334 18.3281 6.10293 18.3281 7.78125C18.3281 10.8291 13.5169 17.6503 12.285 19.3472C12.2522 19.3919 12.2093 19.4283 12.1597 19.4534C12.1102 19.4785 12.0555 19.4916 12 19.4916C11.9445 19.4916 11.8898 19.4785 11.8403 19.4534C11.7907 19.4283 11.7478 19.3919 11.715 19.3472C10.4831 17.6503 5.67188 10.8291 5.67188 7.78125C5.67188 6.10293 6.33859 4.49334 7.52534 3.30659C8.71209 2.11984 10.3217 1.45313 12 1.45312Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_3'
          d='M17.6053 17.4225C20.1666 17.9297 21.8438 18.7762 21.8438 19.7344C21.8438 21.2878 17.4375 22.5469 12 22.5469C6.5625 22.5469 2.15625 21.2878 2.15625 19.7344C2.15625 18.7781 3.82594 17.9334 6.375 17.4253'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </symbol>
    <symbol id={Enums.Kind.thankYou} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g id='award-trophy 1' clipPath='url(#clip0_1770_6157)'>
        <path
          id='Vector'
          d='M7.07812 18.3281H16.9219C16.9219 18.3281 18.3281 18.3281 18.3281 19.7344V21.1406C18.3281 21.1406 18.3281 22.5469 16.9219 22.5469H7.07812C7.07812 22.5469 5.67188 22.5469 5.67188 21.1406V19.7344C5.67188 19.7344 5.67188 18.3281 7.07812 18.3281Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_2'
          d='M8.48438 1.45312H2.41219C2.15783 1.45312 1.91389 1.55417 1.73403 1.73403C1.55417 1.91389 1.45313 2.15783 1.45312 2.41219C1.45313 5.20939 2.56431 7.89203 4.54223 9.86995C6.52016 11.8479 9.20279 12.9591 12 12.9591C14.7972 12.9591 17.4798 11.8479 19.4578 9.86995C21.4357 7.89203 22.5469 5.20939 22.5469 2.41219C22.5469 2.15783 22.4458 1.91389 22.266 1.73403C22.0861 1.55417 21.8422 1.45312 21.5878 1.45312H15.5156'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_3'
          d='M10.0144 12.7725L8.38031 18.3281H15.4116L13.9341 12.7818'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_4'
          d='M12.5625 1.75783L13.7325 4.06221H15.7266C15.8361 4.06001 15.9438 4.0908 16.0357 4.15058C16.1275 4.21036 16.1993 4.29637 16.2416 4.39744C16.284 4.49851 16.295 4.60999 16.2732 4.71738C16.2514 4.82478 16.1978 4.92314 16.1194 4.99971L14.2856 6.79877L15.3 9.12846C15.3446 9.23522 15.3546 9.3533 15.3284 9.46603C15.3023 9.57875 15.2414 9.68042 15.1544 9.75668C15.0674 9.83293 14.9586 9.87992 14.8434 9.891C14.7282 9.90209 14.6125 9.87671 14.5125 9.81846L12.0609 8.43752L9.60938 9.81846C9.50941 9.87636 9.39381 9.90145 9.27883 9.8902C9.16386 9.87895 9.05531 9.83192 8.96846 9.75574C8.88162 9.67956 8.82086 9.57806 8.79473 9.46553C8.7686 9.353 8.77842 9.23511 8.82281 9.12846L9.83719 6.79877L8.00625 4.99689C7.92778 4.92028 7.87417 4.82182 7.8524 4.71434C7.83063 4.60685 7.8417 4.4953 7.88416 4.39418C7.92663 4.29306 7.99854 4.20706 8.09053 4.14736C8.18253 4.08765 8.29036 4.057 8.4 4.05939H10.3931L11.5641 1.75502C11.6118 1.66374 11.6837 1.58731 11.7718 1.53407C11.86 1.48084 11.9611 1.45284 12.0641 1.45313C12.1671 1.45342 12.2681 1.48199 12.356 1.53572C12.4439 1.58945 12.5153 1.66628 12.5625 1.75783Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_1770_6157'>
          <rect width='24' height='24' fill='currentColor' />
        </clipPath>
      </defs>
    </symbol>
    <symbol id={Enums.Kind.permissions} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g id='cog 1' clipPath='url(#clip0_2274_13666)'>
        <path
          id='Vector'
          d='M10.6369 3.03544C10.8089 3.22641 11.0191 3.3791 11.254 3.48362C11.4888 3.58813 11.743 3.64214 12 3.64214C12.257 3.64214 12.5112 3.58813 12.746 3.48362C12.9808 3.3791 13.1911 3.22641 13.3631 3.03544L14.25 2.06232C14.5042 1.78101 14.8392 1.58526 15.209 1.50194C15.5789 1.41861 15.9655 1.45179 16.3157 1.59693C16.666 1.74206 16.9627 1.99203 17.1652 2.31254C17.3678 2.63304 17.4661 3.00837 17.4469 3.38701L17.3803 4.69951C17.3674 4.95554 17.4083 5.21144 17.5004 5.45071C17.5924 5.68998 17.7335 5.90732 17.9147 6.08872C18.0958 6.27013 18.3129 6.41158 18.5521 6.50397C18.7912 6.59636 19.0471 6.63763 19.3031 6.62513L20.6156 6.55857C20.994 6.53991 21.3689 6.63874 21.6889 6.8415C22.009 7.04425 22.2585 7.34102 22.4032 7.69113C22.548 8.04124 22.581 8.42755 22.4976 8.79711C22.4142 9.16668 22.2186 9.50142 21.9375 9.75544L20.9606 10.6367C20.7699 10.809 20.6174 11.0193 20.5131 11.2542C20.4087 11.4891 20.3548 11.7433 20.3548 12.0003C20.3548 12.2573 20.4087 12.5115 20.5131 12.7463C20.6174 12.9812 20.7699 13.1916 20.9606 13.3639L21.9375 14.2451C22.2188 14.4993 22.4145 14.8343 22.4979 15.2042C22.5812 15.574 22.548 15.9606 22.4029 16.3109C22.2577 16.6611 22.0078 16.9579 21.6873 17.1604C21.3668 17.3629 20.9914 17.4613 20.6128 17.442L19.3003 17.3754C19.0437 17.3622 18.7872 17.4031 18.5473 17.4953C18.3075 17.5875 18.0897 17.729 17.908 17.9107C17.7263 18.0923 17.5848 18.3102 17.4926 18.55C17.4004 18.7898 17.3596 19.0463 17.3728 19.3029L17.4394 20.6154C17.4561 20.9922 17.3565 21.365 17.1541 21.6831C16.9517 22.0013 16.6562 22.2494 16.3078 22.3938C15.9594 22.5382 15.575 22.5718 15.2069 22.4902C14.8387 22.4085 14.5046 22.2155 14.25 21.9373L13.3678 20.9614C13.1956 20.7707 12.9853 20.6182 12.7505 20.5139C12.5157 20.4095 12.2616 20.3556 12.0047 20.3556C11.7477 20.3556 11.4936 20.4095 11.2588 20.5139C11.024 20.6182 10.8137 20.7707 10.6415 20.9614L9.75561 21.9373C9.50137 22.2168 9.16713 22.411 8.79847 22.4936C8.4298 22.5761 8.04464 22.543 7.6955 22.3987C7.34635 22.2543 7.05022 22.0058 6.84746 21.6871C6.6447 21.3683 6.54519 20.9947 6.56248 20.6173L6.62998 19.3048C6.64318 19.0482 6.60237 18.7917 6.51017 18.5519C6.41797 18.312 6.27645 18.0942 6.09477 17.9125C5.91308 17.7308 5.69527 17.5893 5.45544 17.4971C5.21561 17.4049 4.95909 17.3641 4.70248 17.3773L3.38998 17.4439C3.0115 17.4636 2.63618 17.3658 2.31555 17.1637C1.99492 16.9616 1.7447 16.6652 1.59925 16.3152C1.45379 15.9653 1.42023 15.5788 1.50318 15.209C1.58612 14.8392 1.7815 14.5042 2.06248 14.2498L3.03842 13.3686C3.22915 13.1963 3.38162 12.9859 3.48598 12.751C3.59033 12.5162 3.64425 12.262 3.64425 12.005C3.64425 11.748 3.59033 11.4938 3.48598 11.2589C3.38162 11.024 3.22915 10.8137 3.03842 10.6414L2.06248 9.75544C1.78241 9.50138 1.58763 9.16702 1.50477 8.79807C1.42191 8.42912 1.45502 8.04358 1.59957 7.69416C1.74412 7.34473 1.99305 7.04848 2.31235 6.84589C2.63164 6.6433 3.00571 6.54427 3.38342 6.56232L4.69592 6.62888C4.95301 6.6424 5.21007 6.60169 5.4504 6.50939C5.69073 6.41709 5.90896 6.27527 6.09091 6.09314C6.27286 5.91101 6.41447 5.69265 6.50654 5.45223C6.5986 5.21181 6.63906 4.95471 6.6253 4.69763L6.56248 3.38419C6.54477 3.00663 6.64399 2.6328 6.84659 2.3137C7.04919 1.99461 7.34532 1.7458 7.69455 1.60122C8.04379 1.45665 8.42913 1.42335 8.79799 1.50587C9.16685 1.58839 9.50127 1.78271 9.75561 2.06232L10.6369 3.03544Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_2'
          d='M7.78125 12C7.78125 13.1189 8.22572 14.1919 9.01689 14.9831C9.80806 15.7743 10.8811 16.2188 12 16.2188C13.1189 16.2188 14.1919 15.7743 14.9831 14.9831C15.7743 14.1919 16.2188 13.1189 16.2188 12C16.2188 10.8811 15.7743 9.80806 14.9831 9.01689C14.1919 8.22572 13.1189 7.78125 12 7.78125C10.8811 7.78125 9.80806 8.22572 9.01689 9.01689C8.22572 9.80806 7.78125 10.8811 7.78125 12Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_2274_13666'>
          <rect width='24' height='24' fill='currentColor' />
        </clipPath>
      </defs>
    </symbol>
    <symbol id={Enums.Kind.info} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g id='information-circle 1' clipPath='url(#clip0_1951_10624)'>
        <path
          id='Vector'
          d='M14.1094 16.2188H13.4062C13.0333 16.2188 12.6756 16.0706 12.4119 15.8069C12.1482 15.5431 12 15.1855 12 14.8125V11.2969C12 11.1104 11.9259 10.9316 11.7941 10.7997C11.6622 10.6678 11.4834 10.5938 11.2969 10.5938H10.5938'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_2'
          d='M11.6484 7.78125C11.5552 7.78125 11.4658 7.74421 11.3998 7.67828C11.3339 7.61235 11.2969 7.52293 11.2969 7.42969C11.2969 7.33645 11.3339 7.24703 11.3998 7.1811C11.4658 7.11516 11.5552 7.07812 11.6484 7.07812'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          id='Vector_3'
          d='M11.6484 7.78125C11.7417 7.78125 11.8311 7.74421 11.897 7.67828C11.963 7.61235 12 7.52293 12 7.42969C12 7.33645 11.963 7.24703 11.897 7.1811C11.8311 7.11516 11.7417 7.07812 11.6484 7.07812'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          id='Vector_4'
          d='M12 22.5469C17.8247 22.5469 22.5469 17.8247 22.5469 12C22.5469 6.17531 17.8247 1.45312 12 1.45312C6.17531 1.45312 1.45312 6.17531 1.45312 12C1.45312 17.8247 6.17531 22.5469 12 22.5469Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_1951_10624'>
          <rect width='24' height='24' fill='currentColor' />
        </clipPath>
      </defs>
    </symbol>
    <symbol id={Enums.Kind.websiteTest} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g clipPath='url(#clip0_6266_38801)'>
        <path
          d='M2.75 1.07202H21.25C21.25 1.07202 23.25 1.07202 23.25 3.07202V20.929C23.25 20.929 23.25 22.929 21.25 22.929H2.75C2.75 22.929 0.75 22.929 0.75 20.929V3.07202C0.75 3.07202 0.75 1.07202 2.75 1.07202Z'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M0.769989 5.38599H23.238'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M18.623 5.38599V22.928'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4.07199 9.14893H15.32V13.7809H4.07199V9.14893Z'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4.07199 16.801H8.59499'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4.07199 19.865H8.59499'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M11.745 16.801H15.32V19.865H11.745V16.801Z'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4.83099 1.07202V5.38602'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.60699 1.07202V5.38602'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_6266_38811'>
          <rect width='24' height='24' fill='white' transform='translate(8 8)' />
        </clipPath>
      </defs>
    </symbol>
    <symbol id={Enums.Kind.cardSort} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M15.9846 1.6885H3.32863C3.07985 1.6885 2.84127 1.78732 2.66536 1.96323C2.48945 2.13914 2.39062 2.37773 2.39062 2.6265V21.3765C2.39062 21.6253 2.48945 21.8639 2.66536 22.0398C2.84127 22.2157 3.07985 22.3145 3.32863 22.3145H15.9846C16.2334 22.3145 16.472 22.2157 16.6479 22.0398C16.8238 21.8639 16.9226 21.6253 16.9226 21.3765V2.6255C16.9226 2.37673 16.8238 2.13814 16.6479 1.96223C16.472 1.78632 16.2334 1.6875 15.9846 1.6875V1.6885Z'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.9219 3.32617L20.9109 4.37817C21.1512 4.44178 21.3565 4.59822 21.4816 4.81311C21.6066 5.028 21.6413 5.28376 21.5779 5.52417L17.3359 21.6132C17.2955 21.7662 17.2171 21.9066 17.1079 22.0212'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.39062 18.0957H16.8596'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </symbol>
    <symbol id={Enums.Kind.treeTest} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <rect x='2.16' y='2.16' width='19.68' height='4.68' rx='0.84' stroke='white' strokeWidth='1.32' />
      <rect x='8.16' y='9.66' width='13.68' height='4.68' rx='0.84' stroke='white' strokeWidth='1.32' />
      <rect x='8.16' y='17.16' width='13.68' height='4.68' rx='0.84' stroke='white' strokeWidth='1.32' />
      <path d='M8.25 12H3.75V6.75' stroke='white' strokeWidth='1.5' strokeLinejoin='round' />
      <path d='M8.25 12H3.75V6.75' stroke='white' strokeWidth='1.5' strokeLinejoin='round' />
      <path d='M8.25 19.5H3.75V12' stroke='white' strokeWidth='1.5' strokeLinejoin='round' />
    </symbol>
    <symbol id={Enums.Kind.aiModerationInterview} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g clipPath='url(#clip0_6009_359)'>
        <path
          d='M12.6875 6.50781C12.6875 7.05482 12.9048 7.57943 13.2916 7.96622C13.6784 8.35301 14.203 8.57031 14.75 8.57031C15.297 8.57031 15.8216 8.35301 16.2084 7.96622C16.5952 7.57943 16.8125 7.05482 16.8125 6.50781C16.8125 5.9608 16.5952 5.4362 16.2084 5.0494C15.8216 4.66261 15.297 4.44531 14.75 4.44531C14.203 4.44531 13.6784 4.66261 13.2916 5.0494C12.9048 5.4362 12.6875 5.9608 12.6875 6.50781Z'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.75 9.25781C15.6617 9.25781 16.536 9.61998 17.1807 10.2646C17.8253 10.9093 18.1875 11.7836 18.1875 12.6953'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M7.5 1.69531L20.9376 1.69531C21.3022 1.69531 21.652 1.84018 21.9098 2.09804C22.1677 2.3559 22.3126 2.70564 22.3126 3.07031V14.0703C22.3126 14.435 22.1677 14.7847 21.9098 15.0426C21.652 15.3004 21.3022 15.4453 20.9376 15.4453H14.0626'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M16.8125 15.4453V18.1953'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15.4375 18.1953H18.875'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M1.6875 22.3203C1.6875 20.6793 2.3394 19.1055 3.49978 17.9451C4.66016 16.7847 6.23397 16.1328 7.875 16.1328C9.51603 16.1328 11.0898 16.7847 12.2502 17.9451C13.4106 19.1055 14.0625 20.6793 14.0625 22.3203'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4.5 12C4.5 12.7956 4.81607 13.5587 5.37868 14.1213C5.94129 14.6839 6.70435 15 7.5 15C8.29565 15 9.05871 14.6839 9.62132 14.1213C10.1839 13.5587 10.5 12.7956 10.5 12C10.5 11.2044 10.1839 10.4413 9.62132 9.87868C9.05871 9.31607 8.29565 9 7.5 9C6.70435 9 5.94129 9.31607 5.37868 9.87868C4.81607 10.4413 4.5 11.2044 4.5 12Z'
          stroke='white'
          strokeWidth='1.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M1.5 4.41466C2.92748 4.1277 4.07681 2.96441 4.36418 1.5C4.65162 2.96441 5.80066 4.1277 7.22815 4.41466M7.22815 4.41633C5.80066 4.7033 4.65134 5.86658 4.3639 7.33099C4.07653 5.86658 2.92748 4.7033 1.5 4.41633'
          stroke='white'
          strokeWidth='1.38'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_6009_359'>
          <rect width='22' height='22' fill='white' transform='translate(1 1)' />
        </clipPath>
      </defs>
    </symbol>
  </svg>
));
